import { computed } from 'vue';
import useExperiments from '~/stores/useExperimentsStore';
import { useProductType } from '~/composables/useProductType';
import usePageData from '~/stores/usePageData';
import { useDeviceType } from './utils/useDeviceType';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';

export const useGoogleAiEligibility = () => {
  const { experimentFlags } = useExperiments();
  const { isMaster, isShopTheSet, isConsolidatedLatchKey, isConsolidatedMaster, isConsolidatedStandard } = useProductType();
  const { pageData } = usePageData();
  const { killswitches } = useKillswitches();

  const productId = pageData?.productId;
  const productFlags = pageData?.flags?.groupByProducts?.[productId]?.productFlags;
  const isConsolidatedThirdVariantFlag = !!productFlags?.isConsolidatedThirdVariantFlag;

  const flagsPass =
    !isMaster && !isShopTheSet && !isConsolidatedLatchKey && !isConsolidatedMaster && !isConsolidatedStandard && !isConsolidatedThirdVariantFlag;

  const isAiHeaderPromptsEnabled = !!(experimentFlags?.aiHeaderPrompts || experimentFlags?.aiHeaderPromptsCompare || killswitches?.featureEnabledD);

  const isGoogleAiEnabledUnderProductDetails = !!(experimentFlags?.isGoogleAiEnabled && flagsPass && isAiHeaderPromptsEnabled);
  const isGoogleAiTopPlacementEnabled = !!(experimentFlags?.isGoogleAiTopPlacementEnabled && flagsPass && isAiHeaderPromptsEnabled);

  const isGoogleAiEnabled = isGoogleAiEnabledUnderProductDetails || isGoogleAiTopPlacementEnabled;

  const { isDesktop } = useDeviceType();

  const isGoogleAiUnderImageEnabled = computed(() => !!(isGoogleAiTopPlacementEnabled && isDesktop.value));

  const isGoogleAiAboveProductDetailsEnabled = computed(() => !!(isGoogleAiTopPlacementEnabled && !isDesktop.value));

  return {
    isGoogleAiEnabled,
    isGoogleAiEnabledUnderProductDetails,
    isGoogleAiUnderImageEnabled,
    isGoogleAiAboveProductDetailsEnabled,
  };
};

export default useGoogleAiEligibility;
